import { useMemo } from 'react';
import { CompanyAlias } from 'api';
import { EntityOption, UseEntityOptionsProps } from './useEntityOptions.props';

const toOption = (value: string, label: string, type: EntityOption['type']): EntityOption => ({
  id: value,
  value,
  label,
  type,
});

// The company, its related entities, then acquired aliases (booked on the company's own cap table).
export const useEntityOptions = ({ companyInfo }: UseEntityOptionsProps): EntityOption[] =>
  useMemo(() => {
    const primary =
      companyInfo?.id && companyInfo.name ? [toOption(`company-${companyInfo.id}`, companyInfo.name, 'company')] : [];
    const related = (companyInfo?.child_companies ?? []).map(child =>
      toOption(`company-${child.company_id}`, child.company_name ?? '', 'company')
    );
    const acquired = (companyInfo?.aliases ?? [])
      .filter(alias => alias.kind === CompanyAlias.kind.ACQUIRED)
      .map(alias => toOption(`alias-${alias.id}`, alias.name, 'alias'));
    return [...primary, ...related, ...acquired];
  }, [companyInfo]);
